<template>
    <div id="projects">
        <el-main class="project-section">
            <el-row align="middle" justify="center">
                <el-col :span="24">
                    <h2>经典项目</h2>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-card>
                                <img alt="Project" class="project-image"
                                     src="https://www.tecochina.net/uploads/20241024/ef5d81ba47c859ca9d9d47ed46aaa427.jpg">
                                <h3>德思贤科技与臻鼎达成战略合作</h3>
                                <p>德思贤科技与臻鼎科技签署战略合作框架协议，推动PCB产业节能减碳和永续发展。</p>
                            </el-card>
                        </el-col>
                        <el-col :span="12">
                            <el-card>
                                <img alt="Project" class="project-image"
                                     src="https://jrc2020.oss-cn-shanghai.aliyuncs.com/teco-DL/notice.jpg">
                                <h3>禁止电商平台销售东元产品</h3>
                                <p>东元电机发布通知，禁止经销商在网络电商平台销售东元产品。</p>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-main>
    </div>
</template>

<script setup>

</script>

<style scoped>
.project-section h2 {
    font-size: 30px;
    margin-bottom: 30px;
    text-align: center;
}

.project-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
}

.el-card {
    text-align: left;
}

.el-card h3 {
    font-size: 24px;
    margin-bottom: 10px;
}

.el-card p {
    font-size: 16px;
    color: #666;
}
</style>